import React, { useCallback, useContext, useEffect } from 'react';
import OverflowScroller from '../../../components/OverflowScroller/OverflowScroller';
import { LocationContext } from '../../../context/locationContext';
import { block } from '../../../utils';
import { ItemColumnName } from '../../constants';
import { NavigationListItem } from '../NavigationListItem/NavigationListItem';
import './Navigation.css';
const b = block('navigation');
const Navigation = ({ className, onActiveItemChange, links, activeItemId, }) => {
    const { asPath, pathname } = useContext(LocationContext);
    const hidePopup = useCallback(() => {
        onActiveItemChange();
    }, [onActiveItemChange]);
    useEffect(() => {
        hidePopup();
    }, [hidePopup, asPath, pathname]);
    return (React.createElement(OverflowScroller, { className: b(null, className), onScrollStart: hidePopup },
        React.createElement("nav", null,
            React.createElement("ul", { className: b('links') }, links.map((link, index) => (React.createElement(NavigationListItem, { key: index, className: b('links-item'), item: link, index: index, activeItemId: activeItemId, hidePopup: hidePopup, column: ItemColumnName.Left, onActiveItemChange: onActiveItemChange })))))));
};
export default Navigation;
